var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pt640ListSize !=null )?_c('div',{style:(_vm.htmlAlign)},[(_vm.orderKakuteiFlg == 0)?void 0:[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlTxt)}})]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }